/**
 * Load tracking scripts based on user consent preferences
 * Only runs on client-side to prevent SSR issues
 */

export function loadTrackingScripts(preferences) {
  // Only run on client
  if (typeof window === 'undefined') return;

  // Analytics - Google Ads Conversion
  if (preferences?.analytics) {
    loadGoogleAds();
  }
}

/**
 * Load Google Ads Conversion Tracking
 * ID: AW-11154801660
 */
function loadGoogleAds() {
  if (window.dataLayer === undefined) {
    window.dataLayer = [];
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-11154801660';
  document.head.appendChild(script);

  window.dataLayer.push(arguments);
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', 'AW-11154801660');
}

/**
 * Load Herefish Customer Analytics
 * Account ID: 19ea56dd-4b05-47b1-9f52-11ae38ce961b
 */
export function loadHerefish() {
  window.hfAccountId = '19ea56dd-4b05-47b1-9f52-11ae38ce961b';
  window.hfDomain = 'https://api.herefish.com';

  const hf = document.createElement('script');
  hf.type = 'text/javascript';
  hf.async = true;
  hf.src = window.hfDomain + '/scripts/hf.js';
  const s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(hf, s);
}
